import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './agenda-item.types';

export const agendaItemSelectors = {
  ...generateResourceSelectors<types.IAgendaItem>((state) => state.resource.agendaItem),
};
